module.exports = __webpack_public_path__ + "static/media/Color-Library.0ba6933a.png";